<template>
  <div style="display: inline-block;min-width:600px" class="user">
    <div>
      <table>
        <tr>
          <th>子账户账号:</th>
          <td>{{ info.subAcctNo }}</td>
          <th>银行卡绑定状态:</th>
          <td>
            <span style="color:#ff6224;">{{
              info.status | bankTypeStatus
            }}</span>
          </td>
        </tr>
        <tr>
          <th style="font-size: 20px;font-weight: bold;">银行信息</th>
        </tr>
        <tr>
          <th>银行类型:</th>
          <td>
            <span style="color:#ff6224;">{{ info.bankType | bankType }}</span>
          </td>
          <th>银行名称:</th>
          <td>{{ info.acctOpenBranchName }}</td>
        </tr>
        <tr>
          <th>账户属性:</th>
          <td>{{ info.bindType | jzbbindType }}</td>
          <!-- <th>账户名称:</th>
          <td>{{info.accountName}}</td> -->
          <th>银行卡号:</th>
          <td>{{ info.memberAcctNo | desensitizationBank }}</td>
          <th>手机号:</th>
          <td>{{ info.mobile | desensitizationPhone }}</td>
        </tr>

        <tr>
          <th style="font-size: 20px;font-weight: bold;">商户信息</th>
        </tr>
        <!-- 个人 -->
        <tbody v-if="type === 2">
          <tr>
            <th>姓名:</th>
            <td>{{ info.memberAcctName }}</td>
            <th>个人证件类型:</th>
            <td>{{ cardTypeNameHandler(info.memberGlobalType) }}</td>
            <th>个人证件号码:</th>
            <td>{{ info.memberGlobalNo }}</td>
            <th>个体工商户:</th>
            <td>{{ info.indivBusinessFlag === "1" ? "是" : "否" }}</td>
          </tr>
          <tr v-if="info.indivBusinessFlag === '1'">
            <th>企业名称:</th>
            <td>{{info.companyName}}</td>
            <th>企业证件类型:</th>
            <td>{{cardTypeNameHandler(info.companyGlobalType)}}</td>
            <th>企业证件号码:</th>
            <td>{{info.companyGlobalId}}</td>
            <th>法人{{info.memberAcctName}}:</th>
            <td>{{info.repFlag === "1" ? "是" : "否"}}</td>
          </tr>
          <tr v-if="info.indivBusinessFlag === '1' && info.repFlag === '2'">
            <th>法人姓名:</th>
            <td>{{info.reprName}}</td>
            <th>法人证件类型:</th>
            <td>{{cardTypeNameHandler(info.reprGlobalType)}}</td>
            <th>法人证件号码:</th>
            <td>{{info.reprGlobalId}}</td>
          </tr>
        </tbody>
        <!-- 企业 -->
        <tbody v-if="type === 1">
          <tr>
            <th>企业名称:</th>
            <td>{{ info.memberAcctName }}</td>
            <th>统一社会信用代码:</th>
            <td>{{ info.memberGlobalNo }}</td>
            <th>法人名字:</th>
            <td>{{ info.reprName}}</td>
          </tr>
          <tr>
            <th>法人证件类型:</th>
            <td>{{ cardTypeNameHandler(info.reprGlobalType)}}</td>
            <th>法人证件号:</th>
            <td>{{info.reprGlobalId}}</td>
            <th>存在经办人:</th>
            <td>{{info.agencyClientFlag === "1" ? "是" : "否"}}</td>
          </tr>
          <tr v-if="info.agencyClientFlag === '1'">
            <th>经办人名字:</th>
            <td>{{info.agencyClientGlobalType}}</td>
            <th>经办人证件类型:</th>
            <td>{{cardTypeNameHandler(info.agencyClientName)}}</td>
            <th>经办人证件号:</th>
            <td>{{info.agencyClientGlobalId}}</td>
            <th>经办人手机号:</th>
            <td>{{info.agencyClientMobile}}</td>
          </tr>
        </tbody>
      </table>

      <div class="unbinding-btn">
        <el-button size="mini" @click="unbindingHandler">
          <span class="iconfont icon-jiebang" style="font-size:12px;"></span>
          解绑
        </el-button>
        <el-button
          size="mini"
          @click="gobind"
          v-if="info.status == 1 ? true : false"
        >
          <!-- <span class="iconfont icon-jiebang" style="font-size:12px;"></span> -->
          去鉴权
        </el-button>
      </div>
    </div>

    <el-dialog
      title="解绑"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="500px"
      center
    >
      <span class="text-center">解绑后再次绑定时</span>
      <span class="text-center">开户名、证件类型、证件号不可修改</span>
      <span class="text-center">仍然解绑？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="default"
          >取 消</el-button
        >
        <el-button @click="confirmeUnbindingHandler" type="primary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { jzbReqCardType } from "@/models/jzbModel";
import { desensitization } from "@/utils/utils";
export default {
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    },
    type: {
      type: Number,
      default: function() {
        return '';
      }
    }
    // cardTypeList: {
    //   type: Array,
    //   default: function () {
    //     return []
    //   }
    // }
  },
  filters: {
    desensitizationPhone(val) {
      return desensitization(val, 3, 4);
    },
    desensitizationCard(val) {
      return desensitization(val, 4, 4);
    },
    desensitizationName(val) {
      return desensitization(val, 1, 0);
    },
    desensitizationBank(val) {
      return desensitization(val, 4, 4);
    },
    jzbbindType(type) {
      if (type == 1) {
        return "个人";
      }
      if (type == 2) {
        return "企业";
      }
    }
  },
  data() {
    return {
      showGoBind: false,
      dialogVisible: false,
      cardTypeList: []
    };
  },
  methods: {
    unbindingHandler() {
      this.dialogVisible = true;
    },
    getBindingData() {
      this.$api.get(this.$apiList.jzbVipAccountInfo, {
        // shopId: JSON.parse(localStorage.getItem('shop_id')),
        page: this.currentPage,
        pagesize: this.pagesize
      });
    },
    gobind() {
      this.$emit("gobind");
    },
    confirmeUnbindingHandler() {
      this.$emit("unbinding");
    },
    cardTypeNameHandler(val) {
      let name = "";
      this.cardTypeList.forEach(item => {
        if (item.cid == val) {
          name = item.name;
        }
      });
      return name;
    }
  },
  async created() {
    await jzbReqCardType({}).then(res => {
      if (res.code === 200) {
        this.cardTypeList = res.data;
      } else {
        this.$message({
          message: res.msg,
          type: "warning"
        });
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.unbinding-btn {
  margin: 5px auto;
  text-align: center;
}
table {
  color: #606266;
  font-size: 12px;
  vertical-align: middle;
  border-collapse: separate;
  border-spacing: 0;
  width: 1200px;
  th,
  td {
    padding: 0;
    vertical-align: middle;
    line-height: 1.5;
  }
  th {
    padding: 8px 10px;
    text-align: right;
    font-weight: 500;
  }
  td {
    padding: 8px 7px 8px 0;
    text-align: left;
  }
}
.text-center {
  display: inline-block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/hasBinding.vue